import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"ad-select","item-text":"nome","item-name":"usuarioId","item-value":"usuarioId","items":_vm.users,"label":"AD","placeholder":"AD"},model:{value:(_vm.filter.adId),callback:function ($$v) {_vm.$set(_vm.filter, "adId", $$v)},expression:"filter.adId"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum AD retornado\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }